module.exports = __webpack_public_path__ + "img/banner-phocus.05a532ef.png";